export default "__VITE_ASSET__a6912420__"